import React from 'react';
import { Pagination as AntPagination } from 'antd';
import classNames from 'classnames';
import styles from './pagination.module.scss';
import type { IPagination } from './types';

export const Pagination: React.FC<IPagination> = (props) => {
  const { onChange, total, limit, page, className, withLimitChanger = true } = props;

  if (total === undefined) return null;

  const containerClassname = classNames(styles.container, className);

  return (
    <div className={containerClassname}>
      <AntPagination
        total={total}
        pageSize={limit}
        current={page}
        showSizeChanger={withLimitChanger}
        onChange={onChange}
      />
    </div>
  );
};
